export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/position',
		name: 'NbuPosition',
		title: {
			single: 'NbuPosition',
			plural: 'NbuPositions'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "2817",
				"code": null,
				"name": "Бухгалтер",
				"caption": "Бухгалтер",
				"isBlocked": false
			},
			{
				"id": "2803",
				"code": null,
				"name": "Виконавчий директор",
				"caption": "Виконавчий директор",
				"isBlocked": false
			},
			{
				"id": "20001000049",
				"code": null,
				"name": "ВИКОНАВЧИЙ ДИРЕКТОР ВІДДІЛЕННЯ",
				"caption": "ВИКОНАВЧИЙ ДИРЕКТОР ВІДДІЛЕННЯ",
				"isBlocked": false
			},
			{
				"id": "20001000046",
				"code": null,
				"name": "ВИКОНАВЧИЙ ДИРЕКТОР ФІЛІЇ",
				"caption": "ВИКОНАВЧИЙ ДИРЕКТОР ФІЛІЇ",
				"isBlocked": false
			},
			{
				"id": "20001000186",
				"code": null,
				"name": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ГОЛОВИ ПРАВЛІННЯ",
				"caption": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ГОЛОВИ ПРАВЛІННЯ",
				"isBlocked": false
			},
			{
				"id": "30000001000092",
				"code": null,
				"name": "Виконуючий обов'язки директора агенства",
				"caption": "Виконуючий обов'язки директора агенства",
				"isBlocked": false
			},
			{
				"id": "20001000110",
				"code": null,
				"name": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА ВІДДІЛЕННЯ",
				"caption": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА ВІДДІЛЕННЯ",
				"isBlocked": false
			},
			{
				"id": "30000001000078",
				"code": null,
				"name": "Виконуючий обов'язки директора регіонального офісу",
				"caption": "Виконуючий обов'язки директора регіонального офісу",
				"isBlocked": false
			},
			{
				"id": "30000001000070",
				"code": null,
				"name": "Виконуючий обов'язки директора регіонального управління",
				"caption": "Виконуючий обов'язки директора регіонального управління",
				"isBlocked": false
			},
			{
				"id": "20001000109",
				"code": null,
				"name": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА ФІЛІЇ",
				"caption": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА ФІЛІЇ",
				"isBlocked": false
			},
			{
				"id": "30000001000086",
				"code": null,
				"name": "Виконуючий обов'язки директора центру обслуговування клієнтів",
				"caption": "Виконуючий обов'язки директора центру обслуговування клієнтів",
				"isBlocked": false
			},
			{
				"id": "30000001000096",
				"code": null,
				"name": "Виконуючий обов'язки керівника агенства",
				"caption": "Виконуючий обов'язки керівника агенства",
				"isBlocked": false
			},
			{
				"id": "30000001000082",
				"code": null,
				"name": "Виконуючий обов'язки керівника регіонального офісу",
				"caption": "Виконуючий обов'язки керівника регіонального офісу",
				"isBlocked": false
			},
			{
				"id": "30000001000074",
				"code": null,
				"name": "Виконуючий обов'язки керівника регіонального управління",
				"caption": "Виконуючий обов'язки керівника регіонального управління",
				"isBlocked": false
			},
			{
				"id": "30000001000088",
				"code": null,
				"name": "Виконуючий обов'язки керівника центру обслуговування клієнтів",
				"caption": "Виконуючий обов'язки керівника центру обслуговування клієнтів",
				"isBlocked": false
			},
			{
				"id": "20001000162",
				"code": null,
				"name": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ КЕРУЮЧОГО ВІДДІЛЕННЯМ",
				"caption": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ КЕРУЮЧОГО ВІДДІЛЕННЯМ",
				"isBlocked": false
			},
			{
				"id": "20001000026",
				"code": null,
				"name": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ НАЧАЛЬНИКА ВІДДІЛЕННЯ",
				"caption": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ НАЧАЛЬНИКА ВІДДІЛЕННЯ",
				"isBlocked": false
			},
			{
				"id": "20001000158",
				"code": null,
				"name": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ НАЧАЛЬНИКА ФІЛІЇ",
				"caption": "ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ НАЧАЛЬНИКА ФІЛІЇ",
				"isBlocked": false
			},
			{
				"id": "2800",
				"code": null,
				"name": "Віце-президент",
				"caption": "Віце-президент",
				"isBlocked": false
			},
			{
				"id": "2813",
				"code": null,
				"name": "В.о. Генерального директора",
				"caption": "В.о. Генерального директора",
				"isBlocked": false
			},
			{
				"id": "2805",
				"code": null,
				"name": "В.о. Голови правління",
				"caption": "В.о. Голови правління",
				"isBlocked": false
			},
			{
				"id": "20001000156",
				"code": null,
				"name": "В.О. ГОЛОВИ РАДИ",
				"caption": "В.О. ГОЛОВИ РАДИ",
				"isBlocked": false
			},
			{
				"id": "20001000157",
				"code": null,
				"name": "В.О. ГОЛОВИ ТОВАРИСТВА",
				"caption": "В.О. ГОЛОВИ ТОВАРИСТВА",
				"isBlocked": false
			},
			{
				"id": "30000001000130",
				"code": null,
				"name": "В.о. головного бухгалтера",
				"caption": "В.о. головного бухгалтера",
				"isBlocked": false
			},
			{
				"id": "2814",
				"code": null,
				"name": "В.о. Директора",
				"caption": "В.о. Директора",
				"isBlocked": false
			},
			{
				"id": "30000001000126",
				"code": null,
				"name": "В.О. ДИРЕКТОРА  ДИРЕКЦІЇ",
				"caption": "В.О. ДИРЕКТОРА  ДИРЕКЦІЇ",
				"isBlocked": false
			},
			{
				"id": "30000001000106",
				"code": null,
				"name": "В.о. завідувача відділенням",
				"caption": "В.о. завідувача відділенням",
				"isBlocked": false
			},
			{
				"id": "20001000155",
				"code": null,
				"name": "В.О. КЕРІВНИКА",
				"caption": "В.О. КЕРІВНИКА",
				"isBlocked": false
			},
			{
				"id": "30000001000122",
				"code": null,
				"name": "В.о. начальника відокремленого підрозділу",
				"caption": "В.о. начальника відокремленого підрозділу",
				"isBlocked": false
			},
			{
				"id": "30000001000112",
				"code": null,
				"name": "в.о. начальника управління",
				"caption": "в.о. начальника управління",
				"isBlocked": false
			},
			{
				"id": "30000001000108",
				"code": null,
				"name": "В.о. начальника філії",
				"caption": "В.о. начальника філії",
				"isBlocked": false
			},
			{
				"id": "2812",
				"code": null,
				"name": "В.о. Президента",
				"caption": "В.о. Президента",
				"isBlocked": false
			},
			{
				"id": "2790",
				"code": null,
				"name": "Генеральний директор",
				"caption": "Генеральний директор",
				"isBlocked": false
			},
			{
				"id": "30000001000110",
				"code": null,
				"name": "Генеральний директор відокремленого підрозділу",
				"caption": "Генеральний директор відокремленого підрозділу",
				"isBlocked": false
			},
			{
				"id": "2819",
				"code": null,
				"name": "Голова Комісії",
				"caption": "Голова Комісії",
				"isBlocked": false
			},
			{
				"id": "20001000207",
				"code": null,
				"name": "ГОЛОВА ЛІКВІДАЦІЙНОЇ КОМІСІЇ",
				"caption": "ГОЛОВА ЛІКВІДАЦІЙНОЇ КОМІСІЇ",
				"isBlocked": false
			},
			{
				"id": "2785",
				"code": null,
				"name": "Голова правління",
				"caption": "Голова правління",
				"isBlocked": false
			},
			{
				"id": "2791",
				"code": null,
				"name": "Голова Правління",
				"caption": "Голова Правління",
				"isBlocked": false
			},
			{
				"id": "20001000150",
				"code": null,
				"name": "ГОЛОВА ПРАВЛІННЯ (ГЕНЕРАЛЬНИЙ ДИРЕКТОР)",
				"caption": "ГОЛОВА ПРАВЛІННЯ (ГЕНЕРАЛЬНИЙ ДИРЕКТОР)",
				"isBlocked": false
			},
			{
				"id": "2799",
				"code": null,
				"name": "Голова Правління-Генеральний директор",
				"caption": "Голова Правління-Генеральний директор",
				"isBlocked": false
			},
			{
				"id": "2798",
				"code": null,
				"name": "Голова Правління-Директор",
				"caption": "Голова Правління-Директор",
				"isBlocked": false
			},
			{
				"id": "2794",
				"code": null,
				"name": "Голова правління-Президент",
				"caption": "Голова правління-Президент",
				"isBlocked": false
			},
			{
				"id": "2809",
				"code": null,
				"name": "Голова Ради",
				"caption": "Голова Ради",
				"isBlocked": false
			},
			{
				"id": "2818",
				"code": null,
				"name": "Голова Товариства",
				"caption": "Голова Товариства",
				"isBlocked": false
			},
			{
				"id": "2793",
				"code": null,
				"name": "Головний бухгалтер",
				"caption": "Головний бухгалтер",
				"isBlocked": false
			},
			{
				"id": "2780",
				"code": null,
				"name": "Головний економіст",
				"caption": "Головний економіст",
				"isBlocked": false
			},
			{
				"id": "2775",
				"code": null,
				"name": "Головний економіст-фінансист",
				"caption": "Головний економіст-фінансист",
				"isBlocked": false
			},
			{
				"id": "30000001000053",
				"code": null,
				"name": "Головний спеціаліст відділу фінансового моніторингу ",
				"caption": "Головний спеціаліст відділу фінансового моніторингу ",
				"isBlocked": false
			},
			{
				"id": "2816",
				"code": null,
				"name": "Державний секретар",
				"caption": "Державний секретар",
				"isBlocked": false
			},
			{
				"id": "2783",
				"code": null,
				"name": "Директор",
				"caption": "Директор",
				"isBlocked": false
			},
			{
				"id": "30000001000090",
				"code": null,
				"name": "Директор агенства",
				"caption": "Директор агенства",
				"isBlocked": false
			},
			{
				"id": "20001000047",
				"code": null,
				"name": "ДИРЕКТОР ВІДДІЛЕННЯ",
				"caption": "ДИРЕКТОР ВІДДІЛЕННЯ",
				"isBlocked": false
			},
			{
				"id": "20001000151",
				"code": null,
				"name": "ДИРЕКТОР ВІДОКРЕМЛЕННОГО СТРУКТУРНОГО ПІДРОЗДІЛУ",
				"caption": "ДИРЕКТОР ВІДОКРЕМЛЕННОГО СТРУКТУРНОГО ПІДРОЗДІЛУ",
				"isBlocked": false
			},
			{
				"id": "20001000161",
				"code": null,
				"name": "ДИРЕКТОР ДЕПАРТАМЕНТУ",
				"caption": "ДИРЕКТОР ДЕПАРТАМЕНТУ",
				"isBlocked": false
			},
			{
				"id": "30000001000124",
				"code": null,
				"name": "ДИРЕКТОР ДИРЕКЦІЇ",
				"caption": "ДИРЕКТОР ДИРЕКЦІЇ",
				"isBlocked": false
			},
			{
				"id": "20001000159",
				"code": null,
				"name": "ДИРЕКТОР ПРЕДСТАВНИЦТВА",
				"caption": "ДИРЕКТОР ПРЕДСТАВНИЦТВА",
				"isBlocked": false
			},
			{
				"id": "30000001000076",
				"code": null,
				"name": "Директор регіонального офісу",
				"caption": "Директор регіонального офісу",
				"isBlocked": false
			},
			{
				"id": "30000001000068",
				"code": null,
				"name": "Директор регіонального управління",
				"caption": "Директор регіонального управління",
				"isBlocked": false
			},
			{
				"id": "20001000021",
				"code": null,
				"name": "ДИРЕКТОР ФІЛІЇ",
				"caption": "ДИРЕКТОР ФІЛІЇ",
				"isBlocked": false
			},
			{
				"id": "30000001000084",
				"code": null,
				"name": "Директор центру обслуговування кліентів",
				"caption": "Директор центру обслуговування кліентів",
				"isBlocked": false
			},
			{
				"id": "2781",
				"code": null,
				"name": "Економіст I категорії",
				"caption": "Економіст I категорії",
				"isBlocked": false
			},
			{
				"id": "20001000149",
				"code": null,
				"name": "ЗАВІДУВАЧ ВІДДІЛЕННЯМ",
				"caption": "ЗАВІДУВАЧ ВІДДІЛЕННЯМ",
				"isBlocked": false
			},
			{
				"id": "30000001000120",
				"code": null,
				"name": "Завідувач ломбарду",
				"caption": "Завідувач ломбарду",
				"isBlocked": false
			},
			{
				"id": "20001000000",
				"code": null,
				"name": "ЗАВІДУЮЧИЙ ВІДДІЛЕННЯМ",
				"caption": "ЗАВІДУЮЧИЙ ВІДДІЛЕННЯМ",
				"isBlocked": false
			},
			{
				"id": "20001000024",
				"code": null,
				"name": "ЗАВІДУЮЧИЙ ФІЛІЄЮ",
				"caption": "ЗАВІДУЮЧИЙ ФІЛІЄЮ",
				"isBlocked": false
			},
			{
				"id": "2770",
				"code": null,
				"name": "Заст. начальника управління-начальник відділу",
				"caption": "Заст. начальника управління-начальник відділу",
				"isBlocked": false
			},
			{
				"id": "30000001000056",
				"code": null,
				"name": "Заступник  керуючого",
				"caption": "Заступник  керуючого",
				"isBlocked": false
			},
			{
				"id": "2808",
				"code": null,
				"name": "Заступник генерального директора",
				"caption": "Заступник генерального директора",
				"isBlocked": false
			},
			{
				"id": "2788",
				"code": null,
				"name": "Заступник Голови правління",
				"caption": "Заступник Голови правління",
				"isBlocked": false
			},
			{
				"id": "2784",
				"code": null,
				"name": "Заступник Державного секретаря",
				"caption": "Заступник Державного секретаря",
				"isBlocked": false
			},
			{
				"id": "2797",
				"code": null,
				"name": "Заступник директора",
				"caption": "Заступник директора",
				"isBlocked": false
			},
			{
				"id": "2771",
				"code": null,
				"name": "Заступник міністра",
				"caption": "Заступник міністра",
				"isBlocked": false
			},
			{
				"id": "2776",
				"code": null,
				"name": "Заступник начальника відділу",
				"caption": "Заступник начальника відділу",
				"isBlocked": false
			},
			{
				"id": "2773",
				"code": null,
				"name": "Заступник начальника департаменту",
				"caption": "Заступник начальника департаменту",
				"isBlocked": false
			},
			{
				"id": "2774",
				"code": null,
				"name": "Заступник начальника управління",
				"caption": "Заступник начальника управління",
				"isBlocked": false
			},
			{
				"id": "30000001000058",
				"code": null,
				"name": "Заступник начальника філії",
				"caption": "Заступник начальника філії",
				"isBlocked": false
			},
			{
				"id": "2806",
				"code": null,
				"name": "Заступник Президента",
				"caption": "Заступник Президента",
				"isBlocked": false
			},
			{
				"id": "2777",
				"code": null,
				"name": "Інспектор I категорії",
				"caption": "Інспектор I категорії",
				"isBlocked": false
			},
			{
				"id": "2801",
				"code": null,
				"name": "Керівник",
				"caption": "Керівник",
				"isBlocked": false
			},
			{
				"id": "30000001000094",
				"code": null,
				"name": "Керівник агенства",
				"caption": "Керівник агенства",
				"isBlocked": false
			},
			{
				"id": "20001000069",
				"code": null,
				"name": "КЕРІВНИК ВІДДІЛЕННЯ",
				"caption": "КЕРІВНИК ВІДДІЛЕННЯ",
				"isBlocked": false
			},
			{
				"id": "20001000129",
				"code": null,
				"name": "КЕРІВНИК ВІДОКРЕМЛЕНОГО ПІДРОЗДІЛУ",
				"caption": "КЕРІВНИК ВІДОКРЕМЛЕНОГО ПІДРОЗДІЛУ",
				"isBlocked": false
			},
			{
				"id": "30000001000080",
				"code": null,
				"name": "Керівник регіонального офісу",
				"caption": "Керівник регіонального офісу",
				"isBlocked": false
			},
			{
				"id": "30000001000072",
				"code": null,
				"name": "Керівник регіонального управління",
				"caption": "Керівник регіонального управління",
				"isBlocked": false
			},
			{
				"id": "20001000089",
				"code": null,
				"name": "КЕРІВНИК ФІЛІЇ",
				"caption": "КЕРІВНИК ФІЛІЇ",
				"isBlocked": false
			},
			{
				"id": "2802",
				"code": null,
				"name": "Керуючий",
				"caption": "Керуючий",
				"isBlocked": false
			},
			{
				"id": "20001000048",
				"code": null,
				"name": "КЕРУЮЧИЙ ВІДДІЛЕННЯМ",
				"caption": "КЕРУЮЧИЙ ВІДДІЛЕННЯМ",
				"isBlocked": false
			},
			{
				"id": "30000001000128",
				"code": null,
				"name": "Керуючий відокремленим підрозділом",
				"caption": "Керуючий відокремленим підрозділом",
				"isBlocked": false
			},
			{
				"id": "20001000023",
				"code": null,
				"name": "КЕРУЮЧИЙ СПРАВАМИ",
				"caption": "КЕРУЮЧИЙ СПРАВАМИ",
				"isBlocked": false
			},
			{
				"id": "30000001000098",
				"code": null,
				"name": "Менеджер агенства",
				"caption": "Менеджер агенства",
				"isBlocked": false
			},
			{
				"id": "20001000025",
				"code": null,
				"name": "МЕНЕДЖЕР ВІДОКРЕМЛЕНОГО ПІДРОЗДІЛУ",
				"caption": "МЕНЕДЖЕР ВІДОКРЕМЛЕНОГО ПІДРОЗДІЛУ",
				"isBlocked": false
			},
			{
				"id": "20001000183",
				"code": null,
				"name": "МЕНЕДЖЕР З НАДАННЯ КРЕДИТІВ ТА ГРОШОВОГО ОБІГУ",
				"caption": "МЕНЕДЖЕР З НАДАННЯ КРЕДИТІВ ТА ГРОШОВОГО ОБІГУ",
				"isBlocked": false
			},
			{
				"id": "30000001000102",
				"code": null,
				"name": "Менеджер із надання кредитів",
				"caption": "Менеджер із надання кредитів",
				"isBlocked": false
			},
			{
				"id": "20001000184",
				"code": null,
				"name": "МЕНЕДЖЕР ПО ГРОШОВОМУ ОБІГУ",
				"caption": "МЕНЕДЖЕР ПО ГРОШОВОМУ ОБІГУ",
				"isBlocked": false
			},
			{
				"id": "20001000152",
				"code": null,
				"name": "МЕНЕДЖЕР (УПРАВИТЕЛЬ) З ПИТАНЬ РЕГІОНАЛЬНОГО РОЗВИТКУ",
				"caption": "МЕНЕДЖЕР (УПРАВИТЕЛЬ) З ПИТАНЬ РЕГІОНАЛЬНОГО РОЗВИТКУ",
				"isBlocked": false
			},
			{
				"id": "2768",
				"code": null,
				"name": "Міністр",
				"caption": "Міністр",
				"isBlocked": false
			},
			{
				"id": "2811",
				"code": null,
				"name": "Міський Голова",
				"caption": "Міський Голова",
				"isBlocked": false
			},
			{
				"id": "20001000020",
				"code": null,
				"name": "НАЧАЛЬНИК ВІДДІЛЕННЯ",
				"caption": "НАЧАЛЬНИК ВІДДІЛЕННЯ",
				"isBlocked": false
			},
			{
				"id": "2772",
				"code": null,
				"name": "Начальник відділу",
				"caption": "Начальник відділу",
				"isBlocked": false
			},
			{
				"id": "30000001000051",
				"code": null,
				"name": "Начальник відділу по роботі з клієнтами та персоналом",
				"caption": "Начальник відділу по роботі з клієнтами та персоналом",
				"isBlocked": false
			},
			{
				"id": "2767",
				"code": null,
				"name": "Начальник департаменту",
				"caption": "Начальник департаменту",
				"isBlocked": false
			},
			{
				"id": "20001000208",
				"code": null,
				"name": "НАЧАЛЬНИК ПРЕДСТАВНИЦТВА",
				"caption": "НАЧАЛЬНИК ПРЕДСТАВНИЦТВА",
				"isBlocked": false
			},
			{
				"id": "30000001000114",
				"code": null,
				"name": "Начальник регіонального управління",
				"caption": "Начальник регіонального управління",
				"isBlocked": false
			},
			{
				"id": "2769",
				"code": null,
				"name": "Начальник управління",
				"caption": "Начальник управління",
				"isBlocked": false
			},
			{
				"id": "20001000022",
				"code": null,
				"name": "НАЧАЛЬНИК ФІЛІЇ",
				"caption": "НАЧАЛЬНИК ФІЛІЇ",
				"isBlocked": false
			},
			{
				"id": "30000001000062",
				"code": null,
				"name": "Начальник центру",
				"caption": "Начальник центру",
				"isBlocked": false
			},
			{
				"id": "0",
				"code": null,
				"name": "Н/В",
				"caption": "Н/В",
				"isBlocked": false
			},
			{
				"id": "30000001000066",
				"code": null,
				"name": "Особа, що має право вчиняти юридичні дії без довіреності",
				"caption": "Особа, що має право вчиняти юридичні дії без довіреності",
				"isBlocked": false
			},
			{
				"id": "2804",
				"code": null,
				"name": "Перший заступник Генерального директора",
				"caption": "Перший заступник Генерального директора",
				"isBlocked": false
			},
			{
				"id": "2787",
				"code": null,
				"name": "Перший заступник Голови Правління",
				"caption": "Перший заступник Голови Правління",
				"isBlocked": false
			},
			{
				"id": "2786",
				"code": null,
				"name": "Перший заступник Голови правління",
				"caption": "Перший заступник Голови правління",
				"isBlocked": false
			},
			{
				"id": "2782",
				"code": null,
				"name": "Перший заступник Мiнiстра",
				"caption": "Перший заступник Мiнiстра",
				"isBlocked": false
			},
			{
				"id": "2810",
				"code": null,
				"name": "Повноважний представник",
				"caption": "Повноважний представник",
				"isBlocked": false
			},
			{
				"id": "2789",
				"code": null,
				"name": "Президент",
				"caption": "Президент",
				"isBlocked": false
			},
			{
				"id": "2807",
				"code": null,
				"name": "Президент-Голова Правління",
				"caption": "Президент-Голова Правління",
				"isBlocked": false
			},
			{
				"id": "2779",
				"code": null,
				"name": "Провідний економіст",
				"caption": "Провідний економіст",
				"isBlocked": false
			},
			{
				"id": "2778",
				"code": null,
				"name": "Провідний економіст-фінансист",
				"caption": "Провідний економіст-фінансист",
				"isBlocked": false
			},
			{
				"id": "2792",
				"code": null,
				"name": "Провідний спеціаліст",
				"caption": "Провідний спеціаліст",
				"isBlocked": false
			},
			{
				"id": "20001000160",
				"code": null,
				"name": "СЕКРЕТАР ПРАВЛІННЯ",
				"caption": "СЕКРЕТАР ПРАВЛІННЯ",
				"isBlocked": false
			},
			{
				"id": "4430",
				"code": null,
				"name": "Секретар ради фонду",
				"caption": "Секретар ради фонду",
				"isBlocked": false
			},
			{
				"id": "20001000068",
				"code": null,
				"name": "СТАРШИЙ ЕКОНОМІСТ ПО ФІНАНСОВІЙ РОБОТІ",
				"caption": "СТАРШИЙ ЕКОНОМІСТ ПО ФІНАНСОВІЙ РОБОТІ",
				"isBlocked": false
			},
			{
				"id": "30000001000104",
				"code": null,
				"name": "Старший менеджер",
				"caption": "Старший менеджер",
				"isBlocked": false
			},
			{
				"id": "20001000185",
				"code": null,
				"name": "СТАРШИЙ МЕНЕДЖЕР З НАДАННЯ КРЕДИТІВ ТА ГРОШОВОГО ОБІГУ",
				"caption": "СТАРШИЙ МЕНЕДЖЕР З НАДАННЯ КРЕДИТІВ ТА ГРОШОВОГО ОБІГУ",
				"isBlocked": false
			},
			{
				"id": "30000001000100",
				"code": null,
				"name": "Т.В.О. Генерального директора",
				"caption": "Т.В.О. Генерального директора",
				"isBlocked": false
			},
			{
				"id": "30000001000064",
				"code": null,
				"name": "Тимчасовий адміністратор",
				"caption": "Тимчасовий адміністратор",
				"isBlocked": false
			},
			{
				"id": "20001000182",
				"code": null,
				"name": "ТИМЧАСОВО ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ГОЛОВИ ПРАВЛІННЯ",
				"caption": "ТИМЧАСОВО ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ГОЛОВИ ПРАВЛІННЯ",
				"isBlocked": false
			},
			{
				"id": "30000001000116",
				"code": null,
				"name": "ТИМЧАСОВО ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА",
				"caption": "ТИМЧАСОВО ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА",
				"isBlocked": false
			},
			{
				"id": "20001000206",
				"code": null,
				"name": "ТИМЧАСОВО ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА ФІЛІЇ",
				"caption": "ТИМЧАСОВО ВИКОНУЮЧИЙ ОБОВ'ЯЗКИ ДИРЕКТОРА ФІЛІЇ",
				"isBlocked": false
			},
			{
				"id": "20001000154",
				"code": null,
				"name": "УПОВНОВАЖЕНИЙ НА ВЕДЕННЯ СПРАВ",
				"caption": "УПОВНОВАЖЕНИЙ НА ВЕДЕННЯ СПРАВ",
				"isBlocked": false
			},
			{
				"id": "2815",
				"code": null,
				"name": "Фінансовий директор",
				"caption": "Фінансовий директор",
				"isBlocked": false
			},
			{
				"id": "2795",
				"code": null,
				"name": "Член правління",
				"caption": "Член правління",
				"isBlocked": false
			},
			{
				"id": "2796",
				"code": null,
				"name": "Член правління, головний бухгалтер",
				"caption": "Член правління, головний бухгалтер",
				"isBlocked": false
			},
			{
				"id": "2820",
				"code": null,
				"name": "Член ради фонду",
				"caption": "Член ради фонду",
				"isBlocked": false
			}
		],
	},
}
